import {
  APP_SETTING_TOGGLE_PROFILER_BEGIN,
  APP_SETTING_TOGGLE_PROFILER_SUCCESS,
  APP_SETTING_TOGGLE_PROFILER_FAILURE,
  APP_SETTING_TOGGLE_PROFILER_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function toggleProfiler(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_TOGGLE_PROFILER_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const header = builderSurfaceJsonContentHeader(args.projectId);
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/projects/${args.projectId}/toggle-profiling`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_TOGGLE_PROFILER_SUCCESS,
              data: res.data,
            });
            toast.success('Updated Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_TOGGLE_PROFILER_FAILURE,
              data: { error: err },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_TOGGLE_PROFILER_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissToggleProfilerError() {
  return {
    type: APP_SETTING_TOGGLE_PROFILER_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_TOGGLE_PROFILER_BEGIN:
      return {
        ...state,
        toggleProfilerPending: true,
        toggleProfilerError: null,
      };

    case APP_SETTING_TOGGLE_PROFILER_SUCCESS:
      return {
        ...state,
        toggleProfilerPending: false,
        toggleProfilerError: null,
        projectDetail: action.data,
      };

    case APP_SETTING_TOGGLE_PROFILER_FAILURE:
      return {
        ...state,
        toggleProfilerPending: false,
        toggleProfilerError: action.data.error,
      };

    case APP_SETTING_TOGGLE_PROFILER_DISMISS_ERROR:
      return {
        ...state,
        toggleProfilerError: null,
      };

    default:
      return state;
  }
}
